var _rect, _circle, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 56",
    role: "img",
    "aria-label": "9mobile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 56,
    rx: 12,
    fill: "#d7df23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 25,
    r: 14,
    fill: "#153f2e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 32,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 21,
    fontWeight: 700,
    fill: "#fff"
  }, "9")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 61,
    y: 30,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#153f2e"
  }, "mobile")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineMobile);
export default __webpack_public_path__ + "static/media/nine-mobile.7279ecd9376230c4afe49e1b5cf754a9.svg";
export { ForwardRef as ReactComponent };